import type { FC } from 'react';
import React from 'react';
import cx from 'classnames';

import cypressIds from 'Components/cypress_ids.json';
import Skeleton from 'Storybook/core/Skeleton/Skeleton';
import { applyCypressData } from 'Utilities/helpers';

import styles from './InsightsLoadingSkeleton.module.scss';

const LoadingSkeletonDataGrid: FC = () => (
	<div className={styles.mockDatagridContainer}>
		<div className={cx(styles.mockSectionHeaderContainer, styles.flexSpaceBetweenContainer)}>
			<Skeleton height={4} width={8} />
			<div className={styles.mockDatagridHeaders}>
				<Skeleton height={4} width={9} />
				<Skeleton height={4} width={8} />
				<Skeleton height={4} width={14} />
				<Skeleton height={4} width={12} />
				<Skeleton height={4} width={10} />
			</div>
		</div>
		<div className={styles.mockDatagridRows}>
			<Skeleton isFullWidth height={6} />
			<Skeleton isFullWidth height={6} />
			<Skeleton isFullWidth height={6} />
			<Skeleton isFullWidth height={6} />
			<Skeleton isFullWidth height={6} />
		</div>
	</div>
);

const LoadingSkeletonDataListElement: FC = () => (
	<div className={styles.mockDataListElement}>
		<Skeleton height={3} width={23} />
		<Skeleton isFullWidth height={6} />
	</div>
);

const LoadingSkeletonDataList: FC = () => (
	<>
		<div className={styles.mockDataListContainer}>
			<LoadingSkeletonDataListElement />
			<LoadingSkeletonDataListElement />
			<LoadingSkeletonDataListElement />
			<LoadingSkeletonDataListElement />
			<LoadingSkeletonDataListElement />
		</div>
		<Skeleton className={styles.mockDataListPagination} height={6} width={23} />
	</>
);

const InsightsLoadingSkeleton: FC = () => {
	return (
		<div {...applyCypressData(cypressIds.containers.insightsLoading)} className={styles.container}>
			<div className={styles.mockSectionHeaderContainer}>
				<Skeleton className={styles.mockSectionHeader} />
			</div>
			<div className={styles.mockStatsContainer}>
				<Skeleton isFullWidth className={styles.mockStatCard} />
				<Skeleton isFullWidth className={styles.mockStatCard} />
				<Skeleton isFullWidth className={styles.mockStatCard} />
			</div>
			<div className={cx(styles.mockSectionHeaderContainer, styles.flexSpaceBetweenContainer)}>
				<Skeleton className={styles.mockSectionHeader} />
				<Skeleton className={styles.mockPaginationDatagrid} height={6} width={26} />
			</div>
			<LoadingSkeletonDataList />
			<LoadingSkeletonDataGrid />
		</div>
	);
};

export default InsightsLoadingSkeleton;
